// color names reference taken from https://www.color-blindness.com/color-name-hue/
export const color = {
    shade: {
        WHITE: '#FFFFFF', // white rgb(255,255,255)
        WHITE01: 'rgba(255,255,255,0.1)', // white
        WHITEY: '#EDF2F4', // anti-flash-white
        NEUTRAL: '#BCBDC8', // ghost
        NEUTRAL05: 'rgba(188, 189, 200, 0.5)', // ghost
        NEUTRAL07: 'rgba(188, 189, 200, 0.75)', // ghost
        GRAYBLUE: '#2B2D42', //gunmetal
        GRAY: '#414645', //outer space
        DARK: '#46495D', // blue zodiac, rgb(70,73,93)
        DARK05: 'rgba(70,73,93,0.5)', // blue zodiac
        TRANSPARENT: 'rgba(0,0,0,0)'
    },
    brand: {
        PRIMARY: '#FF0000', // red, rgb(255,0,0)
        PRIMARY_HOVER: 'rgba(255,0,0,0.5)' // red
    },
    utility: {
        ERROR: '#FF3B6A', // radical red
        APPROVE: '#5DE05B', // pastel green
        ATTENTION: '#FFBB56', // golden tainoi
        DISABLED: '#C8C9CF' // ghost
    }
}